import type { PromptSection, PromptSectionDraft, PromptSuggestEditDraft } from 'services/types/promptSection';

import baseApi from './baseApi';

const promptSectionsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getPromptSections: build.query({
      query: (params: { businessUnitId: number }) => ({
        url: `/promptSections?businessUnitId=${params.businessUnitId}`,
        method: 'GET',
      }),
      transformResponse: (response: PromptSection[]) => response,
    }),
    createPromptSection: build.mutation<
      PromptSection,
      { businessUnitId: number; promptSection: PromptSectionDraft; activatePromptVersion?: boolean }
    >({
      query: (params) => ({
        url: `/promptSections?businessUnitId=${params.businessUnitId}`,
        method: 'POST',
        body: { ...params.promptSection, activatePromptVersion: params.activatePromptVersion },
      }),
      transformResponse: (response: PromptSection) => response,
      invalidatesTags: (_result, _error, { businessUnitId }) => [
        { type: 'BusinessUnitPromptVersions' as const, id: businessUnitId },
      ],
    }),
    suggestEditPromptSection: build.mutation({
      query: (params: { businessUnitId: number; promptSection: PromptSuggestEditDraft }) => ({
        url: `/promptSections/suggestion?businessUnitId=${params.businessUnitId}`,
        method: 'POST',
        body: params.promptSection,
      }),
      transformResponse: (response: PromptSection) => response,
    }),
  }),
  overrideExisting: false,
});

export const { useGetPromptSectionsQuery, useCreatePromptSectionMutation, useSuggestEditPromptSectionMutation } =
  promptSectionsApi;
